import React, {useState} from "react";
import classNames from "classnames";
import AnimateHeight from "react-animate-height";
import styles from "./Notification.module.scss";
import { Button, Span } from "./../../";
import { ErrorIcon, InfoIcon, NoticeTriangleIcon, SuccessIcon } from "@netapp/bxp-style/react-icons/Notification";
import { CloseIcon } from "@netapp/bxp-style/react-icons/Action";

export const iconTypeMapper = {
    error: { icon: ErrorIcon },
    warning: { icon: NoticeTriangleIcon },
    success: { icon: SuccessIcon },
    info: { icon: InfoIcon },
    urgent: { icon: NoticeTriangleIcon }
};

export default ({ type, children, moreInfoClassName, moreInfo, onClose, className, style, messageStyle, isGlobal, dataTestId = `${type}-notification` }) => {
    const [showMore, setShowMore] = useState(false);
    const Icon = iconTypeMapper[type].icon;
    const hasMore = !!moreInfo;
    const closeable = !!onClose;

    return (
        <div data-testid={dataTestId} className={classNames(styles["base"], styles[type], className, {[styles['global']]: isGlobal})} style={style}>
            <Icon className={styles["icon"]}/>
            <div style={messageStyle}>
                <div>
                    <Span bold>{children}</Span>
                    {hasMore && <Button variant="text" onClick={() => setShowMore(!showMore)} className={styles['show-more']}>
                        {showMore ? "Show Less" : "Show More"}
                    </Button>}
                </div>
                <AnimateHeight
                    duration={ 400 }
                    easing="cubic-bezier(.25,.8,.25,1)"
                    height={ showMore ? "auto" : 0 }
                    contentClassName={styles['more-wrapper']}
                >
                    <div className={classNames(styles["more"], moreInfoClassName)}>
                        <Span>{moreInfo}</Span>
                    </div>
                </AnimateHeight>
            </div>
            {closeable && <Button variant="icon" color="secondary" onClick={onClose} className={styles.close}><CloseIcon/></Button>}
            {!closeable && <div/>}
        </div>
    );
};
